class RelatedProductsSwiper {
  constructor() {
    this.init();
  }

  init() {
    // Wait for DOM and Swiper to be ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.waitForSwiper());
    } else {
      this.waitForSwiper();
    }
  }

  waitForSwiper() {
    // Check if Swiper is available, if not wait a bit
    if (typeof Swiper === 'undefined') {
      setTimeout(() => this.waitForSwiper(), 100);
      return;
    }
    
    // Wait for product recommendations to load
    this.waitForProductRecommendations();
  }

  waitForProductRecommendations() {
    const productRecommendations = document.querySelector('product-recommendations');
    
    if (!productRecommendations) {
      return;
    }


    // Check if recommendations are already loaded
    const existingSwiper = productRecommendations.querySelector('.related-products-swiper');
    if (existingSwiper) {
      this.initSwipers();
      return;
    }

    // Listen for when the product-recommendations component finishes loading
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList') {
          const addedNodes = Array.from(mutation.addedNodes);
          const hasSwiperContainer = addedNodes.some(node => 
            node.nodeType === 1 && (
              node.classList?.contains('related-products-swiper') ||
              node.querySelector?.('.related-products-swiper')
            )
          );
          
          if (hasSwiperContainer) {
            observer.disconnect(); // Stop observing
            setTimeout(() => this.initSwipers(), 100); // Small delay to ensure DOM is stable
          }
        }
      });
    });

    // Observe changes within the product-recommendations element
    observer.observe(productRecommendations, {
      childList: true,
      subtree: true
    });

  }

  initSwipers() {
    // Log all elements that might be related for debugging
    
    const swiperContainers = document.querySelectorAll('.related-products-swiper');
    
    if (swiperContainers.length === 0) {
      return;
    }
    
    swiperContainers.forEach((container) => {
      this.initializeSwiper(container);
    });
  }

  initializeSwiper(container) {
    const sectionId = container.dataset.sectionId;
    
    const swiper = new Swiper(container, {
      // Basic settings
      slidesPerView: 1.2,
      spaceBetween: 20,
      loop: false,
      
      // Responsive breakpoints
      breakpoints: {
        // From 768px to 1279px - 2 slides per view with arrows
        768: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        // Above 1280px - 3 slides per view without arrows
        1280: {
          slidesPerView: 3,
          spaceBetween: 24,
        }
      },

      // Navigation arrows
      navigation: {
        nextEl: `[data-section-id="${sectionId}"] .swiper-next`,
        prevEl: `[data-section-id="${sectionId}"] .swiper-prev`,
      },

      // Pagination
      pagination: {
        el: `[data-section-id="${sectionId}"] .swiper-pagination`,
        clickable: true,
        dynamicBullets: true,
      },

      // Touch settings
      touchRatio: 1,
      touchAngle: 45,
      grabCursor: true,

      // Keyboard control
      keyboard: {
        enabled: true,
        onlyInViewport: true,
      },

      // Debug events
      on: {
        init: function() {
        },
        slideChange: function() {
        }
      }
    });


    // Handle arrow visibility after swiper is initialized
    this.addArrowVisibilityHandler(container);
  }

  addArrowVisibilityHandler(container) {
    const arrows = container.querySelector('.swiper-arrow-wrapper');
    if (!arrows) return;

    const updateVisibility = () => {
      const windowWidth = window.innerWidth;
      if (windowWidth >= 1280) {
        // Hide arrows above 1280px
        arrows.style.display = 'none';
      } else {
        // Show arrows below 1280px
        arrows.style.display = 'flex';
      }
    };

    // Initial check
    updateVisibility();

    // Listen for resize events
    window.addEventListener('resize', updateVisibility);
  }
}

// Initialize when the script loads
new RelatedProductsSwiper();

// Also reinitialize on Shopify section events (theme editor)
document.addEventListener('shopify:section:load', () => {
  new RelatedProductsSwiper();
});

// Fallback: Also try after DOM is fully loaded
document.addEventListener('DOMContentLoaded', () => {
  setTimeout(() => new RelatedProductsSwiper(), 1000);
});